<template>
  <div id="bannerView">
    <!-- banner -->
    <div class="swiper ban_swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in bannarList" :key="index">
          <img @click='tolink(item)' :src="item.banner" alt="" />
        </div>
      </div>
      <div class="swiper-pagination-banner"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { downloadA } from '@/utils/download'
import { customText } from '@/utils/key'
export default {
  data() {
    return {
      pcSwiper: null,
    };
  },
  created() { },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.homeSwiper();
      });
    }, 300);

  },
  computed: {
    ...mapState({
      bannarList: (state) => state.init.bannarList,
    })
  },
  methods: {
    tolink(item) {

      switch (item.type) {
        case 1:
          downloadA(item.url)
          break;
        case 2:
          if (item.content) {
            localStorage.setItem(customText, item.content);
            let href = window.location.href
            window.open(`${href}custom`)
          }
          break;
        case 3:
          if (item.url) {
            this.$router.push({
              path: item.url,
            })
          }
          break;
        default:
          break;
      }
    },
    homeSwiper() {
      //banner轮播图
      this.pcSwiper = new Swiper(".ban_swiper", {
        // spaceBetween: 30,
        // centeredSlides: true,

        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination-banner",
          bulletClass: "banner-bullet",
          clickable: true,
        },
        // loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper，主要是这两行
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      });
      this.pcSwiper.el.onmouseover = () => {
        this.pcSwiper.autoplay.stop();
      };
      this.pcSwiper.el.onmouseleave = () => {
        this.pcSwiper.autoplay.start();
      };
    },
  },
};
</script>
<style>
.banner-bullet {
  display: inline-block;
  width: 0.875rem
    /* 70/80 */
  ;
  height: 0.0875rem
    /* 7/80 */
  ;
  background: #fff;
  margin-right: 0.175rem
    /* 14/80 */
  ;
  border-radius: 0.0625rem
    /* 5/80 */
  ;
}

.swiper-pagination-banner .swiper-pagination-bullet-active {
  background-color: #ff0000 !important;
  width: 0.5rem;
  transition: all 0.3s linear;
}

.swiper-pagination-banner {
  position: absolute;
  z-index: 9;
  bottom: 0.25rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style lang="scss" scoped>
#bannerView {
  width: 100%;
  background: #000 !important;

  .ban_swiper {
    max-width: 1920px;
    width: 100%;
    height: 10.875rem;
  }

  /* .swiper-slide {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
} */
  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
<style scoped lang="scss"></style>
